import React from "react"
import Loadable from "react-loadable"
import { Spin } from "antd"

const styles = {
  loadingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%"
  }
}

const loadable = (fn: () => any) =>
  Loadable({
    loader: fn,
    loading: () => (
      <div style={styles.loadingWrapper}>
        <Spin tip="页面加载中,请稍后" />
      </div>
    )
  })

export default loadable
